import React, { Component } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";




export default class Testimonials extends Component {
  render() {
    return (
      <Carousel
        showArrows={true}
        infiniteLoop={true}
        showThumbs={false}
        showStatus={false}
        autoPlay={true}
        interval={6100}
      >
        <div>
          <img src="/images/abdin.jpg" />
          <div className="myCarousel">
            <h3>Md. Joynal Abdin</h3>
            <h4>Executive Secretary at Dhaka Chamber(DCCI)</h4>
            <p>
            He knows right web development tools, 
            a problem-solver with a can-do attitude. Our project was a success! Good job
            </p>
          </div>
        </div>

        <div>
          <img src="/images/damaris.jpg" />
          <div className="myCarousel">
            <h3>Damaris Onyendi</h3>
            <h4>Account Management Executive|| Entrepreneur</h4>
            <p>
            He believe in his work, and keeps him fully vested in seeing a project from initiation to close.
            </p>
          </div>
        </div>

        <div>
          <img src="/images/fatimah.jpg" />
          <div className="myCarousel">
            <h3>Fatimah Oladipo (ACIPM)</h3>
            <h4>Talent Acquisition Specialist</h4>
            <p>
            His specialties are Identifying, developing, managing high 
            performance teams, business development, market research and business strategy, project management, client engagement, 
            innovative and creative problem solving.
            </p>
          </div>
        </div>

        <div>
          <img src="/images/jenifer.jpg" />
          <div className="myCarousel">
            <h3>Jennifer Ahize</h3>
            <h4>People|Product|Process</h4>
            <p>
            elix delivers awesome UI/UX designs. I love the fact that he is highly skilled 
            and invest alot acquiring knowledge. I recommend the quality of his works.
            </p>
          </div>
        </div>

        <div>
          <img src="/images/mobolade.jpg" />
          <div className="myCarousel">
            <h3>Mobolade Akinlua</h3>
            <h4>Software Engineer at Access Bank Plc</h4>
            <p>
            I have worked with Felix on several occasions, he has great skills and 
            instinctive information to function present day gadgets successfully. 
            he understands technical concepts and knows how to apply them in numerous settings.
            </p>
          </div>
        </div>

        <div>
          <img src="/images/Ibrahim.jpg" />
          <div className="myCarousel">
            <h3>Ibrahim Bashir</h3>
            <h4>Founder and CEO at Dillali</h4>
            <p>
            Solid communication, reliable and responsible, collaborative, dynamic tuning in with problem-solving abilities.
            </p>
          </div>
        </div>

        <div>
          <img src="/images/stella.jpg" />
          <div className="myCarousel">
            <h3>Stella Uddin (ANIPR)</h3>
            <h4>MDigital Marketer | Customer Service</h4>
            <p>
            Possess good data analysis & interpretation skills when it comes to digital marketing. he deals with any kind of marketing platform, audience, content. Timely delivery and meeting deadlines.
            </p>
          </div>
        </div>

        <div>
          <img src="/images/datto.jpg" />
          <div className="myCarousel">
            <h3>Dato Dr. Shahril Haniffa</h3>
            <h4>Managing Director at MAHSA University</h4>
            <p>
            Experienced Educational Consultant with a demonstrated history of working in the education management industry.
            </p>
          </div>
        </div>
      </Carousel>
    );
  }
}